<template>
  <div>
    <el-card
      class="card-container"
      shadow="never"
    >
      <CardHeader
        slot="header"
        title="Lịch sử yêu cầu - phê duyệt"
        :total="total"
        :size="'small'"
        :disabled="loading"
        @refresh="handleRefresh"
      />
      <div>
        <CardFilter
          @search="handleSearch"
        />
        <CardList
          :data="data"
          :document-data="documentData"
          :accounts="accounts"
          :loading="loading"
          @detail="handleDetail"
        />
        <el-row
          type="flex"
          align="middle"
          justify="end"
          class="mt-l"
        >
          <el-pagination
            background
            :current-page="page"
            :page-sizes="[10, 20, 50, 100, 500, 1000]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleChangePageSize"
            @current-change="handleChangePage"
          />
        </el-row>
      </div>
    </el-card>
    <RequestHistoryPopup
      v-if="formVisible"
      :visible="formVisible"
      :item="selectedItem"
      :document-data="documentData"
      @close="() => formVisible = false"
    />
  </div>
</template>

<script>
import CardFilter from "./components/CardFilter.vue";
import CardHeader from "./components/CardHeader.vue";
import CardList from "./components/CardList.vue";
import RequestHistoryPopup from "@/components/popups/RequestHistory.vue";

import extraServices from "@/services/extra";
import organizationServices from "@/services/organization";
import commonServices from "@/services/common";
import accountServices from "@/services/account";

import { accountPer } from "@/utils/permission";

import constants from "@/config/constants";

export default {
  name: "Requests",
  components: {
    CardHeader,
    CardFilter,
    CardList,
    RequestHistoryPopup
  },
  data() {
    return {
      loading: false,
      searchText: "",
      contractId: "",
      page: 1,
      pageSize: constants.PAGE_SIZE,
      total: 0,
      data: [],
      documentData: [],
      accounts: [],
      selectedItem: null,
      formVisible: false,
      organizationId: organizationServices.getCurrentOrg()?.id,
      accountPer: accountPer()
    };
  },
  computed: {
    params() {
      const _params = {
        offset: (this.page - 1) * this.pageSize,
        limit: this.page * this.pageSize,
        locale: "vi",
        sort: "-created",
        filters: {
          organization_id: this.organizationId,
          type: null
        }
      };
      if (this.searchText) {
        _params.filters[`name`] = { $regex: this.searchText }
      }
      if (this.contractId) {
        _params.filters[`extra.contract_id`] = this.contractId
      }
      return _params;
    },
  },
  beforeMount() {
    this.listData();
  },
  methods: {
    listData() {
      this.loading = true;
      extraServices
        .list(this.params)
        .then(async (response) => {
          this.data = response.items.map((item, index) => ({
            ...item,
            stt: index + 1 + this.pageSize * (this.page - 1),
          }));
          await this.listDocumentData(response.items);
          if (this.accountPer.READ) {
            await this.listAllAccounts();
          }
          this.total = response.meta.total;
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    async listDocumentData(data) {
      const documents = data.map((d) => ({
        id: d.extra.document_id,
        type: d.extra.document_type
      }))
      const payloads = constants.OBJECT_TYPES.map((t) => ({
        type: t.value,
        ids: [...new Set(documents.filter((d) => t.role_action === d.type).map((d) => d.id))]
      })).filter((p) => p.ids.length > 0);
      const requests = payloads.map((p) => commonServices.list(p.type, {
        offset: 0,
        limit: p.ids.length,
        locale: "vi",
        filters: {
          id: { $in: p.ids },
        }
      }))
      await Promise.all(requests).then((responses) => {
        this.documentData = (responses.map((response) => response.items).flat());
      })
    },
    async listAllAccounts() {
      await accountServices.list({
        offset: 0,
        limit: 999,
        locale: "vi",
        organization_id: this.organizationId,
      }).then((response) => {
        this.accounts = response.items.map((i) => ({
          id: i.id,
          email: i.email
        }))
      })
    },
    handleSearch(data) {
      this.searchText = data.searchText;
      this.contractId = data.contractId;
      this.page = 1;
      this.listData();
    },
    handleRefresh() {
      this.selectedItem = null;
      this.page = 1;
      this.searchText = "";
      this.listData();
    },
    handleChangePage(page) {
      this.page = page;
      this.listData();
    },
    handleChangePageSize(size) {
      this.page = 1;
      this.pageSize = size;
      this.listData();
    },
    handleDetail(item) {
      this.selectedItem = item;
      this.formVisible = true;
    }
  },
};
</script>

<style lang="scss"></style>
